export const translations = {
  en: {
    code: "en",
    brand: "Saree Tryon Studio",
    nav: {
      catalog: "Explore Sarees",
      login: "Store Login",
      signup: "Open Store",
      dashboard: "Dashboard",
      logout: "Log out",
      tagline: "AI Virtual Try-On",
    },
    landing: {
      eyebrow: "Heritage Reimagined",
      titleA: "Drape every customer",
      titleB: "in a saree, instantly.",
      subtitle:
        "An AI virtual try-on studio for boutique saree stores. Let shoppers see themselves in your sarees — before they buy.",
      ctaPrimary: "See Demo Catalog",
      ctaSecondary: "Open My Store",
      featuresTitle: "How it works",
      features: [
        { k: "01", t: "Upload your sarees", d: "Add flat-lay or model photos with name, fabric and price." },
        { k: "02", t: "Customer picks a saree", d: "She uploads her own full-length photo on your storefront." },
        { k: "03", t: "AI drapes it on her", d: "A photo-real try-on appears in 10–20 seconds, ready to share." },
      ],
      marquee: "HERITAGE REIMAGINED • AI VIRTUAL TRY-ON • DRAPE WITHOUT TRYING •",
    },
    auth: {
      loginTitle: "Welcome back",
      signupTitle: "Open your store",
      email: "Email",
      password: "Password",
      storeName: "Store name",
      whatsapp: "WhatsApp number (with country code)",
      whatsappHelp: "Buyers will reach you here. Example: +919876543210",
      login: "Log in",
      signup: "Create store",
      switchToSignup: "New here? Open a store",
      switchToLogin: "Already have a store? Log in",
    },
    dash: {
      title: "Your studio",
      add: "Add a saree",
      empty: "No sarees yet. Add your first piece to start receiving try-ons.",
      storeLink: "Your storefront link",
      copy: "Copy",
      copied: "Copied!",
      name: "Saree name",
      price: "Price (₹)",
      fabric: "Fabric",
      description: "Short description",
      photo: "Upload saree photo",
      save: "Save saree",
      saving: "Saving…",
      whatsappLabel: "WhatsApp for Buy-Now",
      updateWhatsapp: "Update",
      whatsappSaved: "WhatsApp updated",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: "Delete this saree? This cannot be undone.",
      deleted: "Saree deleted",
      updated: "Saree updated",
      copyLink: "Copy try-on link",
      linkCopied: "Link copied!",
      shopifyUrl: "Shopify product URL (optional)",
      shopifyHelp: "Paste this saree's Shopify product page URL. Customers will be sent here from the try-on result.",
      widgetTitle: "Shopify storefront widget",
      widgetSub: "Paste this one-line snippet into your Shopify theme.liquid (just before </body>). A floating \"Try on with AI\" button will auto-appear on every product page that matches one of your sarees' Shopify URLs.",
      widgetCopy: "Copy snippet",
      widgetCopied: "Snippet copied!",
      stats: {
        title: "Performance",
        tryons: "Total try-ons",
        buys: "Buy-now clicks",
        conv: "Conversion rate",
        last7: "Last 7 days",
        topTitle: "Most tried sarees",
        topEmpty: "No try-ons yet. Share your store link to start.",
        sarees: "Sarees",
      },
    },
    fabrics: ["Silk", "Cotton", "Chiffon", "Georgette", "Banarasi", "Kanjivaram", "Linen", "Organza"],
    catalog: {
      welcome: "Welcome to",
      sub: "Tap any saree to try it on with your own photo.",
      tryon: "Try it on me",
      empty: "This store hasn't added sarees yet.",
      filterAll: "All",
      sortNewest: "Newest",
      sortLowHigh: "Price ↑",
      sortHighLow: "Price ↓",
      search: "Search sarees…",
      noMatch: "No sarees match your filters.",
    },
    tryon: {
      title: "Virtual Try-On",
      step1: "Step 1 — Upload your photo",
      step1Hint: "A clear, full-length photo works best. Plain background, good light.",
      upload: "Choose photo",
      change: "Change photo",
      step2: "Step 2 — Generate",
      generate: "Generate Try-On",
      generating: "Draping your elegance…",
      step3: "Step 3 — Your look",
      download: "Download",
      share: "Share",
      buyNow: "Buy on WhatsApp",
      buyShopify: "Buy this saree",
      retry: "Try again",
      errorTitle: "Couldn't generate try-on",
      errorBody: "Please try a different photo or check your connection.",
      noWa: "Store hasn't set WhatsApp yet.",
      waMsg: (saree, store) => `Hi ${store}! I just tried on the "${saree}" saree on your store. I'd love to buy it.`,
    },
    common: {
      back: "Back",
      loading: "Loading…",
      gotIt: "Got it",
    },
  },
  hi: {
    code: "hi",
    brand: "साड़ी ट्राय-ऑन स्टूडियो",
    nav: {
      catalog: "साड़ियाँ देखें",
      login: "स्टोर लॉगिन",
      signup: "स्टोर खोलें",
      dashboard: "डैशबोर्ड",
      logout: "लॉग आउट",
      tagline: "एआई वर्चुअल ट्राय-ऑन",
    },
    landing: {
      eyebrow: "विरासत, फिर से ज़िंदा",
      titleA: "हर ग्राहक को साड़ी में",
      titleB: "तुरंत दिखाइए।",
      subtitle:
        "साड़ी स्टोर्स के लिए एआई वर्चुअल ट्राय-ऑन। ग्राहक खरीदने से पहले ख़ुद को आपकी साड़ी में देख सकें।",
      ctaPrimary: "डेमो कैटलॉग देखें",
      ctaSecondary: "मेरा स्टोर खोलें",
      featuresTitle: "यह कैसे काम करता है",
      features: [
        { k: "०१", t: "अपनी साड़ियाँ अपलोड करें", d: "नाम, फ़ैब्रिक और दाम के साथ फ़ोटो जोड़ें।" },
        { k: "०२", t: "ग्राहक साड़ी चुने", d: "वह आपके स्टोर पर अपनी पूरी फ़ोटो अपलोड करती है।" },
        { k: "०३", t: "एआई उसपर साड़ी पहना दे", d: "10–20 सेकंड में फ़ोटो-असली ट्राय-ऑन तैयार।" },
      ],
      marquee: "विरासत फिर से • एआई वर्चुअल ट्राय-ऑन • बिना पहने ड्रेप •",
    },
    auth: {
      loginTitle: "वापस स्वागत है",
      signupTitle: "अपना स्टोर खोलें",
      email: "ईमेल",
      password: "पासवर्ड",
      storeName: "स्टोर का नाम",
      whatsapp: "व्हाट्सऐप नंबर (देश कोड के साथ)",
      whatsappHelp: "ग्राहक यहीं संपर्क करेंगे। उदाहरण: +919876543210",
      login: "लॉग इन",
      signup: "स्टोर बनाएँ",
      switchToSignup: "नए हैं? स्टोर खोलें",
      switchToLogin: "स्टोर है? लॉग इन करें",
    },
    dash: {
      title: "आपका स्टूडियो",
      add: "साड़ी जोड़ें",
      empty: "अभी कोई साड़ी नहीं। ट्राय-ऑन शुरू करने के लिए पहली साड़ी जोड़ें।",
      storeLink: "आपके स्टोर का लिंक",
      copy: "कॉपी",
      copied: "कॉपी हो गया!",
      name: "साड़ी का नाम",
      price: "दाम (₹)",
      fabric: "फ़ैब्रिक",
      description: "संक्षिप्त विवरण",
      photo: "साड़ी की फ़ोटो अपलोड करें",
      save: "साड़ी सहेजें",
      saving: "सहेज रहे हैं…",
      whatsappLabel: "व्हाट्सऐप (बाय-नाउ के लिए)",
      updateWhatsapp: "अपडेट",
      whatsappSaved: "व्हाट्सऐप अपडेट हो गया",
      edit: "एडिट",
      delete: "हटाएँ",
      confirmDelete: "इस साड़ी को हटाएँ? यह वापस नहीं आएगी।",
      deleted: "साड़ी हटा दी गई",
      updated: "साड़ी अपडेट हो गई",
      copyLink: "ट्राय-ऑन लिंक कॉपी करें",
      linkCopied: "लिंक कॉपी हो गया!",
      shopifyUrl: "Shopify प्रोडक्ट URL (वैकल्पिक)",
      shopifyHelp: "इस साड़ी का Shopify प्रोडक्ट पेज URL पेस्ट करें। ट्राय-ऑन के बाद ग्राहक यहाँ भेजे जाएँगे।",
      widgetTitle: "Shopify स्टोरफ़्रंट विजेट",
      widgetSub: "इस एक-लाइन स्क्रिप्ट को अपनी Shopify theme.liquid में </body> से पहले पेस्ट करें। हर प्रोडक्ट पेज पर अपने आप \"Try on with AI\" बटन आएगा।",
      widgetCopy: "स्क्रिप्ट कॉपी करें",
      widgetCopied: "स्क्रिप्ट कॉपी हो गई!",
      stats: {
        title: "प्रदर्शन",
        tryons: "कुल ट्राय-ऑन",
        buys: "बाय-नाउ क्लिक",
        conv: "कन्वर्ज़न दर",
        last7: "पिछले 7 दिन",
        topTitle: "सबसे ज़्यादा ट्राय की गई साड़ियाँ",
        topEmpty: "अभी कोई ट्राय-ऑन नहीं। स्टोर लिंक शेयर करें।",
        sarees: "साड़ियाँ",
      },
    },
    fabrics: ["सिल्क", "कॉटन", "शिफ़ॉन", "जॉर्जेट", "बनारसी", "कांजीवरम", "लिनन", "ऑर्गेंज़ा"],
    catalog: {
      welcome: "स्वागत है",
      sub: "किसी भी साड़ी पर टैप करें और अपनी फ़ोटो से ट्राय करें।",
      tryon: "मुझ पर ट्राय करें",
      empty: "इस स्टोर ने अभी साड़ियाँ नहीं जोड़ी हैं।",
      filterAll: "सभी",
      sortNewest: "नई",
      sortLowHigh: "दाम ↑",
      sortHighLow: "दाम ↓",
      search: "साड़ी खोजें…",
      noMatch: "इन फ़िल्टर से कोई साड़ी नहीं मिली।",
    },
    tryon: {
      title: "वर्चुअल ट्राय-ऑन",
      step1: "स्टेप 1 — अपनी फ़ोटो अपलोड करें",
      step1Hint: "साफ़, पूरी लंबाई की फ़ोटो सबसे अच्छी रहती है। सादा बैकग्राउंड, अच्छी रोशनी।",
      upload: "फ़ोटो चुनें",
      change: "फ़ोटो बदलें",
      step2: "स्टेप 2 — जनरेट करें",
      generate: "ट्राय-ऑन जनरेट करें",
      generating: "आपकी एलिगेंस ड्रेप हो रही है…",
      step3: "स्टेप 3 — आपका लुक",
      download: "डाउनलोड",
      share: "शेयर",
      buyNow: "व्हाट्सऐप पर ख़रीदें",
      buyShopify: "यह साड़ी ख़रीदें",
      retry: "फिर कोशिश करें",
      errorTitle: "ट्राय-ऑन नहीं बन पाया",
      errorBody: "कोई और फ़ोटो आज़माएँ या इंटरनेट जाँचें।",
      noWa: "स्टोर ने अभी व्हाट्सऐप नंबर नहीं जोड़ा।",
      waMsg: (saree, store) => `नमस्ते ${store}! मैंने आपके स्टोर पर "${saree}" साड़ी ट्राय की। मुझे यह ख़रीदनी है।`,
    },
    common: {
      back: "वापस",
      loading: "लोड हो रहा है…",
      gotIt: "ठीक है",
    },
  },
};
